import React from 'react';
import LegalPageLayout, { H2, P, UL } from '../../components/LegalPageLayout';

export default function MedicalDisclaimer() {
  return (
    <LegalPageLayout title="Medical Disclaimer" lastUpdated="May 31, 2026" testId="medical-disclaimer-page">
      <div className="bg-accent/10 border-l-4 border-accent p-4 rounded-r-lg mb-4">
        <P>
          <strong>Important:</strong> SecondDoctorOpinion.com provides remote second medical opinions
          based on records you submit. This service is <strong>not</strong> a substitute for an in-person
          physician consultation, emergency care, or your treating physician's care.
        </P>
      </div>

      <H2>Nature of the Service</H2>
      <P>
        Specialists on our platform review the medical records, images, and information you provide and offer
        an independent professional opinion. Because our specialists <strong>do not physically examine you</strong>,
        observe your condition in person, or order diagnostic tests, they may not be aware of facts or
        clinical signs that could affect their opinion. In some cases, such facts may be critical.
      </P>

      <H2>No Doctor-Patient Relationship Created</H2>
      <P>
        Submitting a case and receiving an opinion through SecondDoctorOpinion.com does <strong>not</strong>
        create a doctor-patient relationship in the traditional, longitudinal sense. The opinion is intended
        as additional information to help you make informed decisions in consultation with your primary or
        treating physician.
      </P>

      <H2>Not for Emergencies</H2>
      <P>
        Do <strong>not</strong> use this service for medical emergencies. If you are experiencing chest pain,
        difficulty breathing, severe bleeding, stroke symptoms, suicidal thoughts, or any life-threatening
        condition, call <strong>112</strong> (India emergency) or visit the nearest emergency department
        immediately.
      </P>

      <H2>Limitations</H2>
      <UL>
        <li>Opinions are only as accurate as the records and information provided. Missing, illegible, poorly translated, or low-quality images may lead to incomplete assessments.</li>
        <li>Our specialists do not prescribe medications, order tests, or perform procedures through this platform.</li>
        <li>Treatment decisions remain solely between you and your treating physician.</li>
        <li>An AI-assisted preliminary analysis (using Claude Sonnet 4.5) may be generated to help our specialists draft opinions efficiently. Every AI-assisted draft is independently reviewed, edited, and verified by a specialist registered with the NMC or a State Medical Council before being released to you.</li>
      </UL>

      <H2>Specialist Credentials</H2>
      <P>
        All specialists on our panel are independently verified for Medical Council of India (MCI), State
        Medical Council (SMC), or National Medical Commission (NMC) registration before being approved. We
        verify qualifications, registration numbers, and years of practice. However, SecondDoctorOpinion.com
        is a facilitator — the medical opinion is the personal professional judgment of the individual
        specialist who reviewed your case.
      </P>

      <H2>Acknowledgement</H2>
      <P>
        By submitting a case on SecondDoctorOpinion.com, you acknowledge and accept this Medical Disclaimer
        in full. If you do not agree, please do not use the service.
      </P>
    </LegalPageLayout>
  );
}
